// extracted by mini-css-extract-plugin
module.exports = {"brandTrendingWrap":"Sk"};